// 全局请求管理器
class RequestManager {
  constructor() {
    this.requests = new Map();
  }

  addRequest(key, controller) {
    this.requests.set(key, controller);
  }

  removeRequest(key) {
    this.requests.delete(key);
  }

  cancelRequest(key) {
    const controller = this.requests.get(key);
    if (controller) {
      controller.abort();
      this.requests.delete(key);
    }
  }
  cancelAllRequests() {
    this.requests.forEach((controller, key) => {
      controller.abort();
      this.requests.delete(key);
    });
  }
}

const requestManager = new RequestManager();
export default requestManager;
